import config from '../config';

export function normalizePreferenceUsername(value) {
  return typeof value === 'string' && value.length <= 320 ? value.trim().toLowerCase() : '';
}

function preferenceKey(username, provider) {
  const user = normalizePreferenceUsername(username);
  if (!user || typeof provider !== 'string' || !/^[a-z][a-z0-9-]{0,31}$/.test(provider)) return null;
  return `stepwisedocs:guide-step-ai:model:v1:${encodeURIComponent(config.prefixPath || '')}:${encodeURIComponent(user)}:${provider}`;
}

export function readPreferredGuideStepAiModel(username, provider, models) {
  try {
    const key = preferenceKey(username, provider);
    const saved = key ? window.localStorage.getItem(key) : null;
    return typeof saved === 'string' && saved.length <= 128 && models.some((model) => model.id === saved) ? saved : '';
  } catch {
    // Browser storage can be blocked; the current backend default remains usable.
    return '';
  }
}

export function savePreferredGuideStepAiModel(username, provider, model) {
  try {
    const key = preferenceKey(username, provider);
    if (key && typeof model === 'string' && model.length > 0 && model.length <= 128) {
      window.localStorage.setItem(key, model);
    }
  } catch {
    // Failure to remember a preference must not prevent using the selected model.
  }
}
